export type {
  BlockWithIdAndComponent,
  DynamicZoneRendererProps,
} from "./dynamic-zone-renderer";
export { DynamicZoneRenderer } from "./dynamic-zone-renderer";
